module.exports = __webpack_public_path__ + "img/lagos_01.78b28d73.jpg";